<template>
  <div class="selfinfo">
    <div class="infobox">
      <el-form label-position="right" label-width="120px" ref="formLabelAlign" :model="formLabelAlign">
        <el-form-item label="地区：" v-show="userInfo.personal">
          <el-select v-model="placeData[0]" clearable @change="remoteMethod($event,1)" placeholder="省">
            <el-option v-for="o in province" :key="o.id" :label="o.name" :value="o.id"></el-option>
          </el-select>
          <el-select v-model="placeData[1]" clearable @change="remoteMethod($event,2)" placeholder="市">
            <el-option v-for="o in city" :key="o.id" :label="o.name" :value="o.id"></el-option>
          </el-select><br />
          <el-select v-model="placeData[2]" clearable @change="remoteMethod($event,3)" placeholder="县">
            <el-option v-for="o in county" :key="o.id" :label="o.name" :value="o.id"></el-option>
          </el-select>
          <el-select style="margin:10px 0 0 0" v-model="placeData[3]" clearable @change="remoteMethod($event,4)" placeholder="镇">
            <el-option v-for="o in town" :key="o.id" :label="o.name" :value="o.id"></el-option>
          </el-select><br />
          <el-select style="margin:10px 0 0 0" v-model="placeData[4]" clearable @change="remoteMethod($event,5)" placeholder="村">
            <el-option v-for="o in village" :key="o.id" :label="o.name" :value="o.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="title" label="职位">
          <el-input v-model="formLabelAlign.title"></el-input>
        </el-form-item>
        <el-form-item prop="helpSex" label="性别">
          <el-radio-group v-model="formLabelAlign.helpSex">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="organizationAttr" label="单位属性">
          <el-input v-model="formLabelAlign.organizationAttr"></el-input>
        </el-form-item>
        <el-form-item prop="helpOrganizationName" label="帮扶单位名称">
          <el-input v-model="formLabelAlign.helpOrganizationName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset('formLabelAlign')">重 置</el-button>
          <el-button type="primary" @click="onSubmit">提 交</el-button>
          <el-button type="primary" @click="changePlace">修改地区</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import mixin_area from '@/Mixins/mixin_area'
export default {
  mixins: [ mixin_area ],
  data() {
    return {
      formLabelAlign: {
        helpOrganizationName:'',
        organizationAttr:'',
        title:'',
        helpSex:'男',
      },
      province: [],
      city: [],
      county: [],
      town: [],
      village: [],
      placeData: [],
    }
  },
  methods: {
    onSubmit() {
      let [vm] = [this]
      this.$api.selfInfo(this.formLabelAlign).then(res =>{
        if (res.data.status === 0) {
          vm.$message.success('修改成功')
          vm.getData()
        } else{
          this._status(res.data)
        }
      })
    },
    getData() {
      let vm = this
      vm.$api.get_user_login_info().then(res =>{
        if (res.data.status === 0) {
          let data = JSON.parse(res.data.data)
          vm.formLabelAlign.helpOrganizationName = data.helpOrganizationName
          vm.formLabelAlign.organizationAttr = data.organizationAttr
          vm.formLabelAlign.title = data.title
          vm.formLabelAlign.helpSex = data.helpSex
        } else{
          this._status(res.data)
        }
      })
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.placeData = []
    },
    changePlace() {
      //过滤空字符串
      let place = []
      place = this.placeData.filter(x => x)
      if (place.length==0) {
        this.$message.info('请先选择地区')
      } else {
        this.$api.userInfoChange(this.userInfo.id,place[place.length-1]).then(res =>{
          if (res.data.status === 0) {
            this.$message.success('地区修改成功！请重新登录系统')
          } else {
            this.login = false
            this._status(res.data)
          }
        }) 
      }  
    }
  },
  created() {
    this.getData()
    this.areaGet({value: {areaId:0},key:0})
  }
}
</script>

<style scoped>
.selfinfo{
  height: 80%;
  display:flex;
  justify-content: center;
  align-items: center;
}
.infobox{
  /* background: #fff; */
  color: aqua;
  width: 550px;
  /* box-shadow: 1px 2px 3px #ccc; */
}
</style>